<div class="container-fluid">
  <div *ngIf="allowsVisualization">
    <div style="display: inline-block; width: 35%;">
      <div>
        <div *ngIf="visualizableQuestions?.length > 0">
          <mat-form-field style="width: 90%;">
            <mat-label>{{ 'diary-answersheets.selected_chart_data' | translate }}</mat-label>
            <mat-select
              [id]="'selectionFirstData'"
              [compareWith]="positionEquals"
              [(ngModel)]="visualizabledQuestion1"
              (click)="resetFirstDataFilter()"
              (selectionChange)="selectedQuestionChanged()"
            >
              <mat-form-field *ngIf="visualizableQuestions.length > 2" class="full-width" appearance="fill">
                <mat-label>{{ 'diary-answersheets.filter_chart_data' | translate }}</mat-label>
                <input
                  [id]="'firstQuestionSelection'"
                  autocomplete="off"
                  matInput
                  (keyup)="handleFirstDataFilter()"
                  [(ngModel)]="filter.filter1"
                />
              </mat-form-field>
              <mat-option
                *ngFor="let firstQuestion of (visualizableQuestions1$ | async)"
                [id]="'first_data_option_' + firstQuestion.position"
                [value]="firstQuestion"
                [disabled]="isSelectedQuestion(firstQuestion, visualizabledQuestion2)"
              >
                {{ firstQuestion.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div style="display: inline-block; width: 35%;">
      <div *ngIf="visualizableQuestions?.length > 1">
        <mat-form-field style="width: 90%;">
          <mat-label>{{ 'diary-answersheets.selected_chart_data' | translate }}</mat-label>
          <mat-select
            [id]="'selectionSecondData'"
            [compareWith]="positionEquals"
            [(ngModel)]="visualizabledQuestion2"
            (click)="resetSecondDataFilter()"
            (selectionChange)="selectedQuestionChanged()"
          >
            <mat-form-field *ngIf="visualizableQuestions.length > 2" class="full-width" appearance="fill">
              <mat-label>{{ 'diary-answersheets.filter_chart_data' | translate }}</mat-label>
              <input
                [id]="'secondQuestionSelection'"
                autocomplete="off"
                matInput
                (keyup)="handleSecondDataFilter()"
                [(ngModel)]="filter.filter2"
              />
            </mat-form-field>
            <mat-option
              *ngFor="let secondQuestion of (visualizableQuestions2$ | async)"
              [id]="'second_data_option_' + secondQuestion.position"
              [value]="secondQuestion"
              [disabled]="isSelectedQuestion(secondQuestion, visualizabledQuestion1)"
            >
              {{ secondQuestion.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-8">
      <div *ngIf="allowsVisualization" class="chart-container">
        <div *ngIf="loadingChartData" style="text-align: center;">
          <app-loader></app-loader>
        </div>
        <div [hidden]="loadingChartData || !hasChartData" class="chart-wrapper">
          <button
            matTooltip="{{ 'diary-answersheets.reset_chart' | translate }}"
            class="reset-zoom-btn"
            (click)="resetZoom()"
          >
            &#x21BA;
          </button>
          <canvas #chartCanvas></canvas>
        </div>
        <div *ngIf="!loadingChartData && !hasChartData" class="empty-state">
          <p>{{ 'diary-answersheets.not_enough_data_for_chart' | translate }}</p>
        </div>
      </div>

      <mat-tab-group
        *ngIf="(hasDiaryEntries$ | async) === true"
        (selectedIndexChange)="getSelectedIndexDiaries($event)"
        [selectedIndex]="selected.value"
      >
        <mat-tab
          [attr.id]="'tab_' + entry.id"
          *ngFor="let entry of diaryAnswersheets; let index = index"
          [label]="helper.localizeDateTimestamp(entry.attributes.collected_at, 'datetime')"
        >
        </mat-tab>
      </mat-tab-group>
      <!-- Diary answersheet content-->
      <ng-template #answersheetsDetailsPreviewContainer> </ng-template>
      <div *ngIf="(hasDiaryEntries$ | async) === false" class="mb-3">
        <p>{{('diary-answersheets.diary_entries_not_found' | translate)}}</p>
      </div>
    </div>
    <div class="col-12 col-sm-4">
      <div class="mb-4 text-start">
        <div class="card">
          <div *ngIf="(pagedActivity$ | async)?.length === 0" class="card-body">
            <p class="centering">{{'instance-detail.no_activities_found' | translate}}</p>
          </div>
          <div *ngIf="(pagedActivity$ | async).length !== 0" class="list-group">
            <div
              [attr.id]="'activity_' + activity.id"
              *ngFor="let activity of pagedActivity$ | async"
              class="list-group-item list-group-item-action flex-column align-items-start"
            >
              <div class="row justify-content-around mb-3">
                <div class="col-sm-8">
                  <p class="mb-1">
                    <strong> {{helperActivity.getActivityText(activity) | async}}</strong>
                  </p>
                </div>
                <div class="col-sm-4">
                  <p class="mb-1"><small>{{helper.localizeDateString(activity.attributes.created_at)}}</small></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <div class="mt-3">
            <mat-paginator
              (page)="onPageChangeActivity($event)"
              [length]="(activitiesSubject | async)?.length"
              [showFirstLastButtons]="true"
              [pageSizeOptions]="[10, 20, 50]"
              [pageSize]="20"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
